<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>


  <div id="page-user-list">
    <vs-card>

      <vs-table search stripe :data="structures">
        <template slot="thead">
          <vs-th sort-key="name">Nome</vs-th>
          <vs-th sort-key="name">Apelido</vs-th>
          <vs-th sort-key="name">Salário Base</vs-th>
          <vs-th v-for="component in components" :key="component.id">
          
          <span  v-if="component.abbreviation=='IRPS'">IRPS</span>
          <span  v-if="component.abbreviation=='INSS'">INSS</span>
          <span v-if="component.abbreviation!='INSS' && component.abbreviation!='IRPS'">{{component.name}}</span>
          </vs-th>

          <vs-th></vs-th>


        </template>


        <template slot-scope="{data}">
            <vs-tr v-for="salary in structures" :key="salary.id">
              <vs-td :data="salary.user.name">{{salary.user.name}}</vs-td>
              <vs-td>{{salary.user.surname}}</vs-td>
              <vs-td>{{salary.basic_salary}}.Mt</vs-td>
              <vs-td  v-for="component in components" :key="component.id">
               {{ hasComponent(component.id, salary.employee_structure[0].salary_components) }}
              </vs-td>
              <vs-td>
                  <vs-button class="ml-2" color="success" type="border" size="small" iconPack="feather" icon="icon-edit"
                  :to="{
                    name: 'estrutura-detalhes',
                    params: { estruturaId: salary.employee_structure[0].id },
                  }">Editar</vs-button>

              </vs-td>
            </vs-tr>
            <vs-tr >
              <vs-td class="font-bold">Total:</vs-td>
              <vs-td></vs-td>
              <vs-td class="whitespace-no-wrap font-bold" >{{ totalQuantity }} MT.</vs-td>
              <vs-td  >
              </vs-td>
              <vs-td></vs-td>
            </vs-tr>
      </template>
      </vs-table>
      <div style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
    </vs-card>




    <vs-popup class="holamundo" title="Actualizar Estrutura Salarial" :active.sync="popupEdit">

      <div class="vx-row">
        <div class="vx-col w-full mb-2">

          <label class="mt-8" for="">Tipo de componente</label>
          <select name="Tipo de componente" v-model="component.type"
            class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <option value="1">Dedução</option>
            <option value="2">Remuneração</option>

          </select>
          <!-- <span class="text-danger text-sm"  v-show="errors.has('Tipo de componente')">{{ errors.first('Tipo de componente') }}</span> -->
        </div>
        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Nome</label>
          <vs-input class="w-full mt-2 mb-5" type="text" v-model="component.name" name="Nome do componente" />
          <!-- <span class="text-danger text-sm"  v-show="errors.has('Nome')">{{ errors.first('Nome') }}</span> -->
        </div>

        <div class="vx-col w-full mb-2">
          <label class="mt-8" for="">Abreviação</label>
          <vs-input class="w-full mt-2 mb-5" type="text" v-model="component.abbreviation" />
        </div>
        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button class="ml-auto mt-2" @click="editData">Actualizar</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button>
          </div>

        </div>
      </div>
    </vs-popup>



  </div>

</template>

<script>
import vSelect from 'vue-select'
import http from "../../../../../http-common";

// Store Module

// Cell Renderer


export default {
  components: {
    vSelect,



  },
  data() {
    return {
      total:0,
      teste1: [],
      // selected:[],
      inputs: [{
        component_id: [],
        amount: '',
      }],
      popupAdd: false,
      popupEdit: false,
      name: "",
      abbreviation: "",
      type: "",
      structures: [],
      component: [
        {
          id: '',
          amount: '',
          selectedComponent: '',
        }
      ],
      selected: [],
      quant: "10",

      employees: [],
      currentUser: [],
      arrayObj: [],
      ///////////////Permissoes//////////////////
      canListEmp: false,
      canAddEmp: false,
      canUpdateEmp: false,
      canDeleteEmp: false,
      canApproveEmp: false,

      result: [],
      components: [],
      remuneracao: [],
    }
  },



  mounted() {
    this.initialize();
  },

 computed: {
    totalQuantity() {
      return this.structures.reduce((sum, item) => sum + item.basic_salary, 0);
    },
  },

  methods: {




    initialize() {
      
      this.getComponent();
      this.getStructure();
 
    },

    hasComponent(id, components) {
      let value="-"
      for (let key in components) {
        if (id === components[key].id){
         value = components[key].pivot.amount
        

         if("IRPS" === components[key].abbreviation){
          value= 'Cal. automático'
         }
         if("INSS" === components[key].abbreviation){
          value= 'Cal. automático'
         }
        }
        
      }
      return value
    },


    /////////////////////////////////////teste

    getStructure() {

          this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type:'sound'
      })


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/salaries/salary-structures", config)
        .then((result) => {
           this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.structures = result.data.SalaryStructure
        
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    getComponent() {

      //  this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get("/salaries/components", config)
        .then((result) => {
          //  this.$vs.loading.close()
          this.components = result.data.SalaryComponents

          this.arrayObj = this.components.map(item => {
            return {
              id: item.id,
              label: item.name,
              verify: item.abbreviation
            };
          });
          this.novo = this.components.map(d => d.responsability_name)
          // alert("2")
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },










    popupOpenEdit(component) {
      this.component = component,
        this.popupEdit = true


    },

    async editData() {
      //      this.$validator.validateAll().then(result => {
      // if (result) {
      this.$vs.loading()


      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        name: this.component.name,
        abbreviation: this.component.abbreviation,
        type: this.component.type

      };

      this.$validator.validateAll();
      http
        .put(`/salaries/components/${this.component.id}`, data, config)
        .then((success) => {
          success;
          this.popupEdit = false,

            this.getData(),
            this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Estrutura salarial actualizada com sucesso!",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.err = error.response.data
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          })
        });
      // }})


    },



  },
  
}

</script>

